<script setup lang="ts">
const emit = defineEmits<{
  alert: []
}>();
</script>

<template>
  <div class="flex flex-col justify-center items-center text-center gap-m bg-secondary-40 rounded-xl p-l text-white">
    <Icon
      name="iad-icon:notifications"
      class="size-10"
    />
    <IadTitle
      tag="p"
      class="text-balance"
      :text="$t('property_serp.promo.alert.title')"
    />
    <IadTitle
      tag="span"
      variant="x-small"
      class="text-pretty"
      :text="$t('property_serp.promo.alert.subtitle')"
    />
    <IadBtn
      :text="$t('property_serp.notification.create_alert')"
      @click="emit('alert')"
    />
  </div>
</template>
